import { render, staticRenderFns } from "./MonthlySocsoExport.vue?vue&type=template&id=29bc7c14&scoped=true"
import script from "./MonthlySocsoExport.vue?vue&type=script&lang=js"
export * from "./MonthlySocsoExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bc7c14",
  null
  
)

export default component.exports